export default __webpack_public_path__ + "static/media/icons8-react-512.d45c50da.png";